"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubDejaSouscritPartCorporation = void 0;
exports.ESubDejaSouscritPartCorporation = {
    less_than_5: "less_than_5",
    between_5_10: "between_5_10",
    between_10_25: "between_10_25",
    greater_than_25: "greater_than_25",
};
